import $ from 'jquery';
import { init as initProductDetails } from './details';
import { init as initQtyControls } from './qty-controls';
import { init as initImageGalleryMobile } from './image-gallery-mobile';
import { init as initImageGalleryDesktop } from './image-gallery-desktop';
import { init as initImageLightbox } from './image-lightbox';
import { init as initUpsell } from './upsell';
import { init as initCarousel } from './carousel';
import { init as initQuickView } from './../theme/quick-view';
import { init as initSwatchSlider } from './swatch-slider';
import { init as initOkendoWidgets } from './okendo';
import { init as initStoq } from './stoq';
import { init as initNosto } from './nosto';
import { reloadSections } from '../theme/reload-sections';
const SWATCH_ELEMENT = '[js-color-swatches]';
const reinitAll = ()=>{
    initProductDetails();
    initQtyControls();
    initImageGalleryMobile();
    initImageGalleryDesktop();
    initImageLightbox();
    initCarousel();
    initUpsell();
    initQuickView();
    initSwatchSlider();
    initOkendoWidgets();
    initStoq();
    initNosto();
};
const refreshStoreProduct = async ()=>{
    const sectionIds = [];
    $('.js-smp-reload').each((_, el)=>{
        const idAttr = el.id;
        if (idAttr === null || idAttr === void 0 ? void 0 : idAttr.startsWith('shopify-section-')) {
            sectionIds.push(idAttr.replace('shopify-section-', ''));
        }
    });
    if (!sectionIds.length) return;
    await reloadSections(sectionIds, {
        context: 'current',
        onAfterReplace: reinitAll
    });
};
export const init = async function() {
    $(document).on('click', SWATCH_ELEMENT, (event)=>{
        const href = event.target.attributes['prod-url'].nodeValue;
        if (!href) return;
        window.history.replaceState({}, '', href);
        refreshStoreProduct().catch(console.error);
    });
    $(document).on('keyup', SWATCH_ELEMENT, (event)=>{
        if (event.keyCode === 13) {
            const href = event.target.attributes['prod-url'].nodeValue;
            if (!href) return;
            window.history.replaceState({}, '', href);
            refreshStoreProduct().catch(console.error);
        }
    });
};
